export const initialState = {
    availableA2HChrome: false,
    availableA2HChat: false,
    availableA2HAd: false,
    isFirstMessageSend: false,
    isFirstAd: false,
    promptOrigin: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'AVAILABLE_A2H_CHROME':
            return {
                ...state,
                availableA2HChrome: action.value };
        case 'AVAILABLE_A2H_CHAT':
            return {
                ...state,
                availableA2HChat: action.value };
        case 'AVAILABLE_A2H_AD':
            return {
                ...state,
                availableA2HAd: action.value };
        case 'IS_FIRST_MESSAGE_SEND':
            return {
                ...state,
                isFirstMessageSend: action.value };
        case 'IS_FIRST_AD':
            return {
                ...state,
                isFirstAd: action.value };
        case 'PROMPT_ORIGIN':
            return {
                ...state,
                promptOrigin: action.value };
        default:
            return state;
    }
};
